import * as React from 'react';

import { LinkButtonStrapiProps } from '@/decodo/components/atoms/LinkButton/LinkStrapi';

import { Target, targets } from '../constants/targets';

const ScraperContext = React.createContext<
  | {
      target: Target;
      dashboardAction?: LinkButtonStrapiProps;
      setTarget: React.Dispatch<React.SetStateAction<Target>>;
    }
  | undefined
>(undefined);

function matchScraperToValue(value: string) {
  const match = targets.find((target) => target.name === value);
  if (match) return match;
  return targets[0];
}

export function ScraperProvider({
  children,
  dashboardAction,
  initialTarget,
}: {
  initialTarget: string;
  children: React.ReactNode;
  dashboardAction?: LinkButtonStrapiProps;
}) {
  const [target, setTarget] = React.useState<Target>(
    matchScraperToValue(initialTarget)
  );

  return (
    <ScraperContext value={{ target, setTarget, dashboardAction }}>
      {children}
    </ScraperContext>
  );
}

export function useScraper() {
  const context = React.use(ScraperContext);
  if (context === undefined) {
    throw new Error('useScraper must be used within a ScraperProvider');
  }
  return context;
}
